import React, { Component } from 'react'

class SystemSettingHome extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }
  changed (name, e) {
    this.setState({[name]: e.target.value})
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'defaultSetting':
        this.props.history.push('/admin/default_setting')
        break
      case 'adminUser':
        this.props.history.push('/admin/admin_user')
        break
      default:
        break
    }
  }
  render () {
    return (
      <div>
        <section className='nav nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>システム設定<br />
                    <small>こちらからシステム設定を開始できます。</small>
                  </h3>
                </header>
              </div>
              <div className='page-nav-options'>
                <div className='span9' />
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <div className='box'>
            <div className='box-header'>
              <i className='icon-cog' />
              <h5>システム設定</h5>
            </div>
            <div className='box-content'>
              <p>こちらでは、以下の作業を開始できます。</p>
              <div className='visible-phone text-center'>
                <button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('defaultSetting')}><i className='icon-cog' />初期値設定</button><br /><br />
                <button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('emailChange')}><i className='icon-cog' />事務局管理者設定</button><br /><br />
              </div>
              <table className='hidden-phone'>
                <tbody>
                  <tr>
                    <th><button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('defaultSetting')}><i className='icon-cog' />初期値設定</button></th>
                    <td>　・・・　</td>
                    <td><div className='kw-cushion-menu-msg'>こちらでシステムで利用する初期値の設定ができます。</div></td>
                  </tr>
                  <tr>
                    <th><button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('adminUser')}><i className='icon-cog' />事務局管理者設定</button></th>
                    <td>　・・・　</td>
                    <td><div className='kw-cushion-menu-msg'>こちらで共有ファイルの事務局管理者設定ができます。</div></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default SystemSettingHome



// WEBPACK FOOTER //
// ./src/admin/pages/secure/SystemSettingHome.js